import SimpleParallax from 'simple-parallax-js';

/** Internal helper imports here ... */

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
export default (() => {
  const parallaxImages = [];

  const init = () => {
    document.querySelectorAll(".parallax-image").forEach((el) => {
      const parallaxImage = new SimpleParallax(el, {
        scale: 1
      });
      parallaxImages.push(parallaxImage);
    });
  };

  return {
    init,
    parallaxImages
  };
})();
